import { onMounted, onUnmounted, ref } from 'vue'

import type { Ref } from 'vue'
import type { DeviceType } from '../types/ad-slot-types'

/**
 * Returns the device type based on the window width, if the window is not available (server side), it returns null
 * @returns 'mobile' | 'desktop' | null
 */
export function useDeviceType (): Ref<DeviceType | null> {
  const deviceType = ref<DeviceType | null>(null)

  const updateDeviceType = () => {
    if (typeof window === 'undefined') {
      deviceType.value = null
      return
    }

    const isMobile = window.innerWidth < 799
    deviceType.value = isMobile ? 'mobile' : 'desktop'
  }

  onMounted(() => {
    updateDeviceType()

    // Add resize listener for reactivity
    window.addEventListener('resize', updateDeviceType)
  })

  onUnmounted(() => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', updateDeviceType)
    }
  })

  return deviceType
}
